import { UIGeneralServicesController } from '../../shared/scripts/UIGeneralServicesController.ts';
import { UINotificationActionController } from '../../shared/scripts/notifications/UINotificationActionController.ts';
import { UIMOnlineFriendController } from './ui_friends/UIMOnlineFriendController.ts';
export class UIMGeneralServicesController extends UIGeneralServicesController {
    init() {
        var _this_onlineFriendController;
        (_this_onlineFriendController = this.onlineFriendController) === null || _this_onlineFriendController === void 0 ? void 0 : _this_onlineFriendController.init();
    }
    constructor(uiManager){
        super();
        const notificationPanelController = uiManager === null || uiManager === void 0 ? void 0 : uiManager.mainpageController.headerController.notificationPanelController;
        this.onlineFriendController = new UIMOnlineFriendController(notificationPanelController);
        if (!notificationPanelController) return;
        this.notificationActionController = new UINotificationActionController(notificationPanelController);
    }
}
